var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeactivatedInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 110,
    style: {
      opacity: 0.3
    },
    opacity: 0.3,
    viewBox: "0 0 125 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 110H13.2922L0.196289 99.288L94.1154 21.9695L102.3 25.9401L125 110Z",
    fill: "#8650F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.823 80.5474H0V99.3098H107.823V80.5474Z",
    fill: "#CC99FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80.5473H107.844L91.7802 12.0427H0V80.5473Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6435 69.5298C75.8249 69.5298 90.6669 60.2358 90.6669 48.8257C90.6669 37.4373 75.8249 28.1216 57.6435 28.1216C39.4621 28.1216 24.6201 37.4155 24.6201 48.8257C24.6419 60.2358 39.4621 69.5298 57.6435 69.5298Z",
    fill: "#E6CCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.245 63.2466C63.1444 63.2466 73.6647 55.8289 73.6647 46.7313C73.6647 37.6338 63.1444 30.2161 50.245 30.2161C37.3455 30.2161 26.8252 37.6338 26.8252 46.7313C26.8252 55.8289 37.3455 63.2466 50.245 63.2466Z",
    fill: "#5C18B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2446 57.618C68.3388 57.618 83.1152 44.6807 83.1152 28.7981C83.1152 12.9373 68.3606 0 50.2446 0C32.1505 0 17.374 12.9373 17.374 28.7981C17.374 44.6807 32.1505 57.618 50.2446 57.618Z",
    fill: "#410E81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2446 0C58.3859 0 65.8287 2.59619 71.569 6.89409C72.0711 8.90123 72.3548 10.9956 72.3548 13.1555C72.3548 29.0599 57.6438 41.9754 39.4842 41.9754C31.3429 41.9754 23.9001 39.3792 18.1598 35.0813C17.6578 33.0742 17.374 30.9798 17.374 28.8199C17.374 12.8937 32.085 0 50.2446 0Z",
    fill: "#673E9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7516 31.8961C39.6585 27.5982 44.7004 22.5585 50.2443 17.977C55.7664 22.5585 60.8302 27.62 64.7153 31.8961C66.2868 30.8053 70.2374 26.2456 71.1104 23.4312C68.1857 20.1805 63.2092 16.0135 57.8181 12.2392C61.4195 9.81755 65.0863 7.76678 68.6877 6.37051C66.4832 4.86515 63.995 3.55615 61.0266 2.53076C58.0582 3.27253 54.2386 5.0615 50.2443 7.3959C46.2501 5.08332 42.4305 3.29435 39.4403 2.55258C36.4937 3.57797 34.0055 4.88697 31.801 6.39232C35.3805 7.7886 39.0474 9.81755 42.6487 12.261C37.2576 16.0353 32.303 20.2023 29.3564 23.453C30.2513 26.2674 34.1801 30.8053 35.7516 31.8961Z",
    fill: "#410E81"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7517 31.896C39.6586 27.5981 44.7005 22.5584 50.2444 17.9769C55.7665 22.5584 60.8303 27.6199 64.7154 31.896C66.1559 30.8924 69.4299 27.0745 70.6958 24.2601C67.7274 21.053 63.0784 17.0606 57.6218 13.4172V12.2391C60.8957 10.0574 64.2352 8.18117 67.4655 6.82853C65.5448 5.62861 63.4494 4.55959 60.983 3.70874C58.0147 4.42869 54.2169 6.21766 50.2226 8.53024C46.2284 6.21766 42.4087 4.42869 39.4404 3.70874C36.974 4.55959 34.7913 5.62861 32.8706 6.82853C36.1009 8.18117 39.5277 10.0574 42.5834 12.2391V13.4172C37.5633 17.0606 32.6305 21.053 29.6621 24.2601C30.9062 27.0745 34.333 30.9142 35.7517 31.896Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivatedInactive);
export default __webpack_public_path__ + "static/media/deactivated_inactive.1089e1f4eec5b414235cf4bd8b61129b.svg";
export { ForwardRef as ReactComponent };